import { notifySuccess, notifyFailure, notifyAlert } from 'app/Notifications/actions';
import { visitComponent } from 'app/Router/actions';

import { componentPublish, componentPublishSuccess, componentPublishFailure } from './actions';

/**
 * publish a dynamic a component
 * @param {string} component - the state of the component
 * @param {boolean} publishNow - flag for publsh now
 * @param {string} dateTime - publish time
 * @param {boolean} isTestContent - whether published for testing purposes only
 * @returns {Function} thunk
 */
export const publishComponentThunk = (
  component,
  publishNow,
  dateTime,
  isTestContent = false
) => async (dispatch, _, { api }) => {
  dispatch(notifyAlert(`Publishing component ${component.ComponentName}`));
  try {
    dispatch(componentPublish(component, publishNow, dateTime, isTestContent));
    const publishSuccessResponse = await api.component.publishComponent(
      component,
      publishNow,
      dateTime,
      isTestContent
    );
    dispatch(componentPublishSuccess(component, publishSuccessResponse));
    dispatch(notifySuccess(`Component ${component.ComponentName} is Published `));
    dispatch(visitComponent(publishSuccessResponse.Id, publishSuccessResponse.Version));
  } catch (error) {
    dispatch(componentPublishFailure(component, error));
    dispatch(notifyFailure(error.message));
  }
};
